<div *ngIf="modalOpened" class="modal-backdrop" role="presentation">
  <div class="modal-content" role="dialog" aria-modal="true">

    <!-- PREVIOUS_SESSION -->
    <div *ngIf="step === SessionStep.PREVIOUS_SESSION" class="modal-body">
      <p>{{'SESSION_MANAGEMENT.PREVIOUS_SESSION_TITLE' | translate }}<br>
         {{'SESSION_MANAGEMENT.NEW_OR_CONTINUE' | translate }}
      </p>
      <div class="modal-buttons">
        <button (click)="startNewSession()">{{'SESSION_MANAGEMENT.NEW_BUTTON' | translate }}</button>
        <button (click)="moveToStep(SessionStep.TOKEN)">{{'SESSION_MANAGEMENT.CONTINUE_BUTTON' | translate }}</button>
      </div>
    </div>

    <!-- TOKEN -->
    <div *ngIf="step === SessionStep.TOKEN" class="modal-body">
      <p>{{'SESSION_MANAGEMENT.INSERT_REFERENCE' | translate }}</p>
      <input #referencia type="text" class="input-code" placeholder="{{'SESSION_MANAGEMENT.REFERENCE_CODE_PLACEHOLDER' | translate}}" (focus)="resetMessage()">
      <p>{{'SESSION_MANAGEMENT.FORGOTTEN_REFERENCE' | translate }} 
        <a href="#" (click)="obtenerReferencia($event)">{{'SESSION_MANAGEMENT.RECOVER_REFERENCE' | translate }}</a></p>
      <div class="modal-buttons">
        <button (click)="moveToStep(SessionStep.PREVIOUS_SESSION)">{{'SESSION_MANAGEMENT.BACK_BUTTON' | translate }}</button>
        <button (click)="continueWithToken(referencia.value)">{{'SESSION_MANAGEMENT.CONTINUE_BUTTON' | translate }}</button>
      </div>
      <div *ngIf="errorMessage" class="error-msg">{{ errorMessage }}</div>
    </div>

    <!-- EMAIL -->
    <div *ngIf="step === SessionStep.EMAIL" class="modal-body">
      <p>{{'SESSION_MANAGEMENT.ENTER_EMAIL' | translate }}</p>
      <input type="text" [(ngModel)]="email" placeholder="{{'SESSION_MANAGEMENT.EMAIL_PLACEHOLDER' | translate}}" class="input-code">
      <div *ngIf="errorMessage" class="error-msg">{{ errorMessage }}</div>
      <div class="modal-buttons">
        <button (click)="moveToStep(SessionStep.TOKEN)">{{'SESSION_MANAGEMENT.BACK_BUTTON' | translate }}</button>
        <button (click)="sendSecurityCode()">{{'SESSION_MANAGEMENT.SEND_CODE_BUTTON' | translate }}</button>
      </div>
    </div>

    <!-- CODE -->
    <div *ngIf="step === SessionStep.CODE" class="modal-body">
      <p>{{'SESSION_MANAGEMENT.CODE_SENT' | translate }}</p>
    
      <div class="codes d-flex justify-content-center mb-3" style="max-width: 80%; margin: 0 auto;">
        <input #input0 type="text" class="m-1 text-center form-control rounded" (input)="moveNext(0, $event)"
          (paste)="handlePaste($event)" maxlength="1" tabindex="1">
        <input #input1 type="text" class="m-1 text-center form-control rounded" (input)="moveNext(1, $event)"
          (paste)="handlePaste($event)" maxlength="1" tabindex="2">
        <input #input2 type="text" class="m-1 text-center form-control rounded" (input)="moveNext(2, $event)"
          (paste)="handlePaste($event)" maxlength="1" tabindex="3">
        <input #input3 type="text" class="m-1 text-center form-control rounded" (input)="moveNext(3, $event)"
          (paste)="handlePaste($event)" maxlength="1" tabindex="4">
      </div>
    
      <div *ngIf="errorMessage" class="error-msg mb-4" [innerHTML]="errorMessage | translate"></div>
    
      <div class="modal-buttons">
        <button (click)="moveToStep(SessionStep.EMAIL)" tabindex="5">{{'SESSION_MANAGEMENT.BACK_BUTTON' | translate }}</button>
        <button (click)="validateSecurityCode()" #continueBtn tabindex="6">{{'SESSION_MANAGEMENT.CONTINUE_BUTTON' | translate }}</button>
      </div>
    </div>


  </div>
</div>
